export const palette = {
  alternate: {
    main: '#F9F6FF',
    light: '#F9F8F8',
    dark: '#E5EAF4',
  },
  cardShadow: 'rgba(23, 70, 161, .11)',
  type: 'light',
  primary: {
    main: '#359A99',
    light: '#F6F6F6',
    after: '#6B5A9A',
  },
  secondary: {
    main: '#FFFFFF',
    light: '#D9EDF7',
  },
  text: {
    primary: '#2D2D2D',
    secondary: '#4A5462',
    alternate: '#1F3B61',
    disabled: '#CCC',
    highlight: '#FFF',
    success: '#1CA179',
    border: '#E5EAF4',
  },
  divider: 'rgba(0, 0, 0, 0.12)',
  background: {
    hero1: '#2A3D50',
    main: '#FFFFFF',
    paper: '#FFF',
    default: '#FFF',
    header: '#359A99',
    footer: '#000000',
    level2: '#f7f8fb',
    level1: '#FFF',
    tableHead: '#26306E',
    tableSubhead: '#EBF5F5',
    tableBorder: '#7D808880',
    tableAlternate: '#FFFFFF',
    alternate: '#E5EAF4',
    success: '#DBEFDC',
    error: '#FFEAEA',
    primary: '#26306E',
    secondary: '#F8D859',
    light: '#F8FBFE',
    secondaryLight: 'rgba(238, 246, 250, 0.6)',
    primaryLight: '#D9EDF7',
    ribbon: '#bbe6fb',
    offer: '#E1F0FF',
    hover1: '#6B5A9A',
  },
  surface: {
    light: '#EBF5F5',
    grey: '#F5F5F5',
    pricing: '#EBF5F5',
    learnMore: '#F4F4F4',
    header: '#EBF6FF',
    switch: '#313E50',
  },
  verticalBar: {
    used: '#687462',
    unused: '#F6F6F6',
    unlimited: '#C0C0C0',
  },
};
